// Golf 4 (Frans): Jouw gegevens (0036), weergave per tablet, wijzigingen weggooien,
// verwachte dagen, modules, werklijst en Ramadan op het bord. Zelfde vorm als de nl-bestanden; de
// stukken worden in app.fr.ts, profileApp.fr.ts, modulesApp.fr.ts, werklijstApp.fr.ts en
// weatherPrayer.fr.ts ingehaakt. AMUMIN Beheer (beheerApp) blijft nl/en: alleen de oprichter.
export const appPrivacyRightsFr = {
    title: 'Tes données',
    intro: 'Tout télécharger, retirer quelqu’un de la famille ou supprimer le tableau familial. Ce sont vos données.',
    entry: 'Tes données',
    entryBody: 'Tout télécharger, retirer quelqu’un de la famille, supprimer le tableau familial.',
    exportTitle: 'Tout télécharger',
    exportBody: 'Un seul fichier ZIP avec tout ce qui concerne votre famille : membres, agenda, tâches, repas, messages, informations sur les photos et les choix dans Ce qui convient à notre famille. Avec un résumé lisible.',
    exportOwnerOnly: 'Seul le propriétaire du tableau familial peut tout télécharger.',
    exportStart: 'Préparer le téléchargement',
    exportPending: 'Nous préparons le fichier. Cela prend en général moins d’une minute.',
    exportReady: 'Prêt · {size} · téléchargeable jusqu’à {time}',
    exportOnce: 'Tu peux télécharger le fichier une seule fois. Ensuite, nous l’effaçons.',
    exportDownload: 'Télécharger',
    exportDownloaded: 'Téléchargé le {time}',
    exportExpired: 'Expiré le {time}',
    exportFailed: 'Le fichier n’a pas pu être créé. Réessaie.',
    exportAgain: 'Préparer à nouveau',
    exportMailed: 'Tous les parents reçoivent un e-mail indiquant qu’un téléchargement est prêt.',
    exportStarted: 'Nous préparons le fichier',
    exportSaved: 'Le fichier est dans tes téléchargements',
    mineTitle: 'Seulement tes propres données',
    mineBody: 'Tes propres données et le profil familial qui s’applique à toi, en fichier (JSON).',
    mineButton: 'Télécharger mes données',
    removeTitle: 'Retirer quelqu’un de la famille',
    removeBody: 'Par exemple un enfant qui a quitté la maison ou un ex-partenaire. Cela se fait dans Famille : ouvre la personne et choisis Retirer de la famille.',
    removeToMembers: 'Vers Famille',
    removeButton: 'Retirer de la famille',
    removeConfirmTitle: 'Retirer {name} de la famille ?',
    removeConfirmNow: '{name} disparaît tout de suite de l’app et du tableau. Si {name} a sa propre connexion, elle ne fonctionne plus pour cette famille.',
    removeConfirmLater: 'Tu peux annuler pendant 7 jours. Ensuite, nous rendons {name} anonyme : le nom devient « Ancien membre de la famille », la photo, la date de naissance et les données particulières (croyance, santé, école) disparaissent, ainsi que les rendez-vous et tâches à venir. Ce qui a déjà eu lieu reste, sans nom.',
    removeConfirmProfile: 'Les choix personnels dans Ce qui convient à notre famille et la météo sont effacés tout de suite et ne reviennent pas en cas d’annulation.',
    removeConfirmButton: 'Retirer de la famille',
    removeButtonHouse: 'Retirer du logement',
    removeConfirmTitleHouse: 'Retirer {name} du logement ?',
    removeConfirmNowHouse: '{name} disparaît tout de suite de l’app et du tableau. Si {name} a sa propre connexion, elle ne fonctionne plus pour ce logement.',
    removeConfirmLaterHouse: 'Tu peux annuler pendant 7 jours. Ensuite nous rendons {name} anonyme : le nom devient « {former} », la photo et les données personnelles disparaissent, ainsi que les rendez-vous et tâches à venir. Ce qui a déjà eu lieu (dépenses comprises) reste, sans nom.',
    removeConfirmProfileHouse: 'Les choix propres à {name} (comme les repas et la météo) sont effacés tout de suite et ne reviennent pas en cas d’annulation.',
    removeConfirmButtonHouse: 'Retirer du logement',
    removeConfirmAnywayHouse: 'Retirer du logement quand même',
    removedHouse: '{name} a été retiré du logement',
    removeConfirmLinks: 'Les liens d’agenda créés par {name} (Google, Outlook ou Apple Calendrier) s’arrêtent tout de suite.',
    removeConfirmDevices: '{name} a associé ces tablettes. Elles fonctionnent jusqu’à ce que tu les dissocies :',
    removeUnpairDevice: 'Dissocier la tablette',
    removeDevicePaired: 'associée le {date}',
    removeDeviceUnpaired: '{name} est dissociée',
    removed: '{name} a été retiré(e) de la famille',
    removedListTitle: 'Retirés de la famille',
    removedUntil: 'Annulation possible jusqu’au {time}',
    removedHadLogin: 'Connexion révoquée',
    undo: 'Annuler',
    undone: '{name} est de retour dans la famille',
    undoneNoLogin: '{name} est de retour dans la famille. La connexion n’a pas pu revenir ; invite à nouveau.',
    errorIsOwner: 'Le propriétaire ne peut pas être retiré de la famille.',
    errorIsSelf: 'Tu ne peux pas te retirer toi-même de la famille.',
    errorNeedsOwner: 'Seul le propriétaire peut retirer un autre parent de la famille.',
    errorWindowClosed: 'Les 7 jours sont passés ; l’annulation n’est plus possible.',
    errorAlreadyRemoved: 'Cette personne a déjà été retirée de la famille.',
    errorDeletionUnavailable: 'La suppression n’est pas possible pour le moment. Rien n’est prévu ; réessaie plus tard ou écris-nous.',
    errorConfirmName: 'Le nom ne correspond pas. Recopie exactement le nom de ton tableau familial.',
    errorExportGone: 'Ce fichier n’existe plus. Prépare un nouveau téléchargement.',
    zipHint: 'Tout en un seul ZIP avec un résumé lisible :',
    deleteTitle: 'Supprimer le tableau familial',
    deleteBody: 'Tout ce qui concerne votre famille est effacé : agenda, tâches, repas, messages, photos et réglages. Tu as 30 jours de réflexion.',
    deleteOwnerOnly: 'Seul le propriétaire peut supprimer le tableau familial.',
    deleteButton: 'Supprimer le tableau familial…',
    deleteConfirmTitle: 'Supprimer le tableau familial ?',
    deletePoints: [
        'Dans 30 jours, nous effaçons tout ce qui concerne {household}. Ce ne sera plus récupérable ensuite.',
        'Jusqu’à ce jour, tu peux l’arrêter avec Finalement ne pas supprimer.',
        'D’ici là, les tablettes affichent un message calme, puis s’arrêtent.',
        'Tous les parents reçoivent un e-mail, maintenant et quand tout est effacé.',
    ],
    deleteExportFirst: 'Tout télécharger d’abord ?',
    deleteExportFirstBody: 'Fais une copie avant de supprimer. C’est aussi possible plus tard, jusqu’au jour même.',
    deleteTypeName: 'Tape le nom de ton tableau familial pour confirmer',
    deleteTypeNameHint: 'Exactement : {household}',
    deleteConfirmButton: 'Supprimer dans 30 jours',
    deleteScheduled: 'Le tableau familial sera supprimé le {date}',
    deleteScheduledBody: 'Jusqu’à ce jour, tout fonctionne normalement. Ensuite, nous effaçons tout et tous les parents reçoivent un e-mail.',
    deleteScheduledByAdmin: 'Planifié par AMUMIN, à votre demande.',
    cancelDelete: 'Finalement ne pas supprimer',
    cancelled: 'Le tableau familial est conservé',
    banner: 'Ce tableau familial sera supprimé le {date}.',
    bannerOwner: 'Finalement ne pas supprimer',
    bannerOthers: 'Seul le propriétaire peut l’arrêter.',
    bannerMore: 'En savoir plus',
    formerMember: 'Ancien membre de la famille',
    formerMemberShared: 'Ancien colocataire',
    formerMemberResident: 'Ancien résident',
    summary: {
        title: 'Données de {household}',
        intro: 'Voici toutes les données de votre tableau familial au {date}, telles qu’AMUMIN les conserve. Chaque partie est dans son propre fichier JSON ; tu peux l’ouvrir avec un éditeur de texte ou l’importer dans un autre programme.',
        fileHeader: 'Fichier',
        whatHeader: 'Contenu',
        countHeader: 'Lignes',
        membersTitle: 'Membres',
        memberFormer: 'ancien membre de la famille',
        memberArchived: 'plus actif',
        notIncludedTitle: 'Ce qui n’y figure pas',
        notIncluded: 'Les secrets (mots de passe, codes PIN, codes d’appairage et identifiants des tablettes), les journaux techniques et les copies temporaires des réponses d’autres services. Les photos et enregistrements eux-mêmes n’y sont pas ; seulement quand ils ont été faits et leur taille.',
        rightsTitle: 'Vos droits',
        rights: 'Tu peux faire corriger des données dans l’app elle-même, retirer quelqu’un de la famille ou supprimer tout le tableau familial dans Réglages › Tes données. Des questions ou une réclamation ? Contacte AMUMIN (voir la politique de confidentialité dans l’app) ; tu peux aussi porter plainte auprès de l’autorité néerlandaise de protection des données (Autoriteit Persoonsgegevens).',
        accountTitle: 'Ton compte',
        accountBody: 'L’adresse e-mail avec laquelle tu te connectes et la date de création de ton compte (account.json).',
        domains: {
            household: {
                title: 'Famille et tablettes',
                body: 'Le tableau familial avec le type de foyer, les membres, les connexions (sans mots de passe) et leurs choix d’écran, les pièces, les tablettes, les invitations et la localisation approximative.',
            },
            profile: {
                title: 'Ce qui convient à notre famille',
                body: 'Cuisine, croyance, repas et jours particuliers, avec tous les consentements (y compris retirés).',
            },
            calendar: {
                title: 'Agenda',
                body: 'Rendez-vous, répétitions, qui participe, trajets, rappels et agendas liés.',
            },
            tasks: {
                title: 'Tâches et récompenses',
                body: 'Tâches, qui les a faites, points, récompenses et demandes.',
            },
            food: {
                title: 'Repas',
                body: 'Courses, recettes, menu de la semaine et réserves.',
            },
            // Golf 8 (0049): Kosten delen.
            costs: {
                title: 'Partager les frais',
                body: 'Les dépenses avec leur répartition, les règlements et les périodes clôturées de la maison.',
            },
            family: {
                title: 'Famille et messages',
                body: 'Listes d’envies, contacts, familles liées, conversations et messages.',
            },
            rooms: {
                title: 'Pièces et ménage',
                body: 'Qui dort dans quelle pièce, corvées, planning tournant (absences et échanges), journal du ménage et verrous enfants (sans le code).',
            },
            media: {
                title: 'Photos et enregistrements',
                body: 'Informations sur les photos et enregistrements : type, taille et date.',
            },
            care: {
                title: 'Check-in et cercle familial',
                body: 'Quand « Tout va bien » a été touché, les signaux et qui les a reçus, les pauses, le cercle avec ses droits et les consentements de la personne âgée.',
            },
            weather_prayer: {
                title: 'Météo et heures de prière',
                body: 'Réglages du conseil météo et des heures de prière.',
            },
            growth: {
                title: 'Croissance',
                body: 'Taille et poids avec les consentements, si vous l’utilisez.',
            },
            school: {
                title: 'École',
                body: 'Matières et résultats, si vous l’utilisez.',
            },
            security: {
                title: 'Sécurité',
                body: 'Réseaux de confiance, alertes de sécurité et journal d’audit (qui a fait quoi, sans contenu).',
            },
            privacy: {
                title: 'Demandes de confidentialité',
                body: 'Les téléchargements comme celui-ci, qui a été retiré de la famille et une suppression planifiée.',
            },
            billing: {
                title: 'Abonnement et factures',
                body: 'Ton abonnement et ton mois d’essai, ce qui a changé (résiliation, paiement) et les factures. Nous conservons les factures 7 ans, même après la suppression (obligation légale).',
            },
            // 0068: Gezond op gewicht (persoonlijk).
            kompas: {
                title: 'Poids en forme',
                body: 'Seulement les tiennes : ton consentement, ton profil et ton objectif, ce que tu as mangé, l’eau, le mouvement, les pesées et ta tuile sur le tableau. Dans ton propre espace ; personne d’autre ne le voit.',
            },
            // 0069: Geldzaken.
            money: {
                title: 'Finances',
                body: 'Tes propres espaces, transactions (l’IBAN d’autrui masqué), règles, objectifs et avoirs. Seulement dans le téléchargement de ton propre espace.',
            },
        },
    },
};
export const appEditorG4Fr = {
    discardTitle: 'Abandonner les modifications ?',
    discardBody: 'Ce que tu as saisi sera perdu.',
    discardKeep: 'Continuer à modifier',
    discardConfirm: 'Abandonner',
};
export const appDevicesG4Fr = {
    layout: 'Affichage',
    layoutAuto: 'Automatique',
    layoutAutoHint: 'S’adapte tout seul à l’écran, même quand on tourne la tablette : compact sur un petit écran, large sur un grand écran à l’horizontale, grand sinon.',
    layoutLarge: 'Grand',
    layoutLargeHint: 'Tout le tableau côte à côte, comme sur l’iPad du salon.',
    layoutCompact: 'Compact',
    layoutCompactHint: 'Moins de colonnes et tout plus grand, lisible à 2 mètres. Pour une petite tablette ou un iPad mini.',
    layoutShown: 'Affichage : {layout}',
    // Tablet-breed: breed (en automatisch op elk scherm).
    layoutWide: 'Large',
    layoutWideHint: 'Agenda, tâches et une colonne Aujourd’hui côte à côte. Pour une tablette de 10 pouces ou plus, à l’horizontale.',
};
export const appProfileDaysG4Fr = {
    expectedTag: 'prévu',
    sheet: {
        expected: 'Ce jour n’est pas encore fixé.',
        when: 'Tombe le {dates}.',
        confirm: 'Confirmer le jour',
        confirmHint: 'Confirme-le ou décale-le dans Ce qui convient à notre famille, Jours particuliers.',
    },
};
export const appModulesG4Fr = {
    offBecause: 'Désactivé ({names} est désactivé)',
    exampleA: 'Léa',
    exampleB: 'Hugo',
    holidaysIslamic: 'Aussi l’Aïd al-Fitr et l’Aïd al-Adha selon votre tradition.',
};
export const appWerklijstG4Fr = {
    progressRegion: 'Avancement',
};
export const prayerRamadanFr = {
    word: {
        turkish: 'Ramazan',
        arabic: 'Ramadan',
    },
    imsak: {
        turkish: 'İmsak',
        arabic: 'Imsak',
    },
    sabah: {
        turkish: 'Sabah',
        arabic: 'Fajr',
    },
    iftar: {
        turkish: 'İftar',
        arabic: 'Iftar',
    },
    day: '{word} · jour {n}',
    last: '{word} · dernier jour',
    countdown: 'encore {n} min',
    now: 'C’est l’heure de l’{iftar}',
    tomorrow: 'Demain',
    eve: 'Le {word} commence demain',
};
//# sourceMappingURL=golf4App.fr.js.map